// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4Hdsk","top":"styles_top__3Ie7s","left":"styles_left__kZstf","description":"styles_description__BbZ5s"};